import PropTypes from 'prop-types';
import ListingType from '@domain-group/fe-allhomes-library/lib/enums/listing-type';
import AllhomesBreadcrumbs from '@domain-group/fe-co-allhomes-breadcrumbs';

/* eslint-disable react/forbid-foreign-prop-types */

var ListingDetailsCommonProps = {
  property: PropTypes.shape({
    features: PropTypes.shape({
      keyDetails: PropTypes.arrayOf(PropTypes.shape({}))
    }),
    listing: PropTypes.shape({
      media: PropTypes.shape({
        items: PropTypes.arrayOf(PropTypes.shape({}))
      }),
      type: PropTypes.oneOf(Object.keys(ListingType)).isRequired,
      id: PropTypes.string,
      documents: PropTypes.arrayOf(PropTypes.shape({}))
    }),
    address: PropTypes.shape({
      nearbyPOIs: PropTypes.arrayOf(PropTypes.shape({})),
      coordinates: PropTypes.shape({
        lat: PropTypes.number,
        lon: PropTypes.number
      })
    }),
    development: PropTypes.shape({
      website: PropTypes.string,
      coverImage: PropTypes.string,
      type: PropTypes.string,
      logo: PropTypes.shape({
        image: PropTypes.string,
        foregroundColour: PropTypes.string,
        backgroundColour: PropTypes.string
      }),
      builder: PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string,
        logo: PropTypes.string
      }),
      developer: PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string,
        logo: PropTypes.string,
        url: PropTypes.string
      })
    })
  }),
  breadcrumbs: AllhomesBreadcrumbs.propTypes.items,
  // Homepass
  homepassBookingEnabled: PropTypes.bool,
  privacyUrl: PropTypes.string,
  termsUrl: PropTypes.string,
  homepassEndpoint: PropTypes.string,
  media: PropTypes.shape({
    mobile: PropTypes.bool.isRequired,
    tablet: PropTypes.bool.isRequired,
    desktop: PropTypes.bool.isRequired
  }).isRequired,
  onPropertyHistorySwipeLeft: PropTypes.func,
  onPropertyHistorySwipeRight: PropTypes.func,
  onPropertyHistoryTapLeft: PropTypes.func,
  onPropertyHistoryTapRight: PropTypes.func,
  onPropertyHistoryExpand: PropTypes.func,
  onPropertyHistoryCollapse: PropTypes.func,
  onPropertyHistoryPhoto: PropTypes.func,
  onAddToWatchlist: PropTypes.func,
  referrer: PropTypes.string,
  mobileAdSpot: PropTypes.string,
  disableAnimation: PropTypes.bool,
  // Inspections
  onRemoveFromPlannerClick: PropTypes.func,
  onCalendarDownload: PropTypes.func,
  // Main photo gallery callbacks
  onSlideChange: PropTypes.func,
  onSlideClick: PropTypes.func,
  onSlideLeft: PropTypes.func,
  onSlideRight: PropTypes.func,
  onClose: PropTypes.func,
  initialIndex: PropTypes.number,
  // Property History gallery callbacks
  onPropertyHistoryGalleryChange: PropTypes.func,
  onPropertyHistoryGalleryClick: PropTypes.func,
  onPropertyHistoryGalleryLeft: PropTypes.func,
  onPropertyHistoryGalleryRight: PropTypes.func,
  // External links
  offMarketAdviceLink: PropTypes.string,
  // Promotion
  listinglLocalities: PropTypes.shape({
    regions: PropTypes.arrayOf(PropTypes.number),
    districts: PropTypes.arrayOf(PropTypes.number),
    divisions: PropTypes.arrayOf(PropTypes.number),
    postcodes: PropTypes.arrayOf(PropTypes.number)
  }),
  sponshorship: PropTypes.shape({
    localities: PropTypes.shape({
      regions: PropTypes.arrayOf(PropTypes.number),
      districts: PropTypes.arrayOf(PropTypes.number),
      divisions: PropTypes.arrayOf(PropTypes.number),
      postcodes: PropTypes.arrayOf(PropTypes.number)
    })
  }),
  enquirySection: PropTypes.shape({
    headingCopy: PropTypes.string,
    headingColour: PropTypes.string,
    bodyCopy: PropTypes.string,
    bodyCopyColour: PropTypes.string,
    buttonCopy: PropTypes.string,
    buttonColour: PropTypes.string,
    disclaimerCopy: PropTypes.string,
    disclaimerColour: PropTypes.string,
    destinationURL: PropTypes.string,
    backgroundColour: PropTypes.string,
    logo: PropTypes.shape({
      imageURL: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number
    })
  }),
  clientRenderedDescription: PropTypes.bool,
  // Created by a wrapper to handle clicks on media items
  onClickVirtualTour: PropTypes.func,
  onClickVideo: PropTypes.func
};
var ListingDetailsDefaultValues = {
  property: {},
  breadcrumbs: [],
  homepassBookingEnabled: false,
  homepassEndpoint: '/wsvc/mobile/v1/homepass',
  privacyUrl: 'https://www.homepass.com/privacy/',
  termsUrl: 'https://www.homepass.com/agent/',
  disableAnimation: false,
  onPropertyHistorySwipeLeft: () => {},
  onPropertyHistorySwipeRight: () => {},
  onPropertyHistoryTapLeft: () => {},
  onPropertyHistoryTapRight: () => {},
  onPropertyHistoryExpand: () => {},
  onPropertyHistoryCollapse: () => {},
  onPropertyHistoryPhoto: () => {},
  onAddToWatchlist: () => {},
  onRemoveFromPlannerClick: () => {},
  referrer: null,
  mobileAdSpot: 'adspot-320x50-pos-1',
  onSlideChange: () => {},
  onSlideClick: () => {},
  onSlideLeft: () => {},
  onSlideRight: () => {},
  onClose: () => {},
  initialIndex: 0,
  onPropertyHistoryGalleryChange: () => {},
  onPropertyHistoryGalleryClick: () => {},
  onPropertyHistoryGalleryLeft: () => {},
  onPropertyHistoryGalleryRight: () => {},
  offMarketAdviceLink: null,
  sponsorship: {},
  clientRenderedDescription: true
};
export default ListingDetailsCommonProps;
export { ListingDetailsDefaultValues };